import type { CSSProperties } from "react";

const PATHS = {
  // navigation
  dashboard: "M3 12h7V3H3v9zm0 9h7v-7H3v7zm9 0h7v-9h-7v9zm0-18v7h7V3h-7z",
  inbox: "M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm0 14h-4l-2 2h-2l-2-2H5V5h14v12z",
  play: "M8 5v14l11-7L8 5z",
  governance: "M3 21h18M5 21V10m4 11V7m4 14V4m4 17v-9m4 9v-6",
  change: "M21 12a9 9 0 0 1-15 6.7M3 12a9 9 0 0 1 15-6.7M21 4v6h-6M3 20v-6h6",
  org: "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm-7 8a7 7 0 0 1 14 0",
  twin: "M12 2v20M2 12h20M5 5l14 14M19 5L5 19",
  sources: "M4 6h16M4 12h16M4 18h10",
  knowledge: "M4 4h16v16H4zM4 9h16M9 4v16",
  people: "M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm0 2c-3 0-7 1.5-7 5v2h14v-2c0-3.5-4-5-7-5zm10-2a4 4 0 0 0 0-8M22 18v-2c0-3-3-4.5-5-5",
  trace: "M4 7l5 5-5 5M14 7h6M14 12h6M14 17h6",
  actions: "M13 2L4 14h7l-1 8 9-12h-7l1-8z",
  factory: "M2 22V8l6 4V8l6 4V2h6v20H2z",
  cxoinbox: "M3 7h18l-2 13H5L3 7zm5-3h8a1 1 0 0 1 1 1v2H7V5a1 1 0 0 1 1-1z",
  // top bar
  star: "M12 17l-5.9 3.1 1.1-6.6L2.5 8.8l6.6-1L12 2l2.9 5.9 6.6.9-4.7 4.6 1.1 6.6L12 17z",
  help: "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20zm0-6v.01M12 14c0-2 3-2 3-5a3 3 0 1 0-6 0",
  // misc
  arrow_right: "M5 12h14M13 5l7 7-7 7",
  arrow_up_right: "M7 17L17 7M9 7h8v8",
  chevron_down: "M6 9l6 6 6-6",
  chevron_right: "M9 6l6 6-6 6",
  check: "M5 12l5 5L20 7",
  info: "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20zm0-12v6m0-9v.01",
  warn: "M10.3 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0zM12 9v4m0 4v.01",
  sparkle: "M12 3v3m0 12v3M3 12h3m12 0h3M5.6 5.6l2.1 2.1m8.6 8.6l2.1 2.1M5.6 18.4l2.1-2.1m8.6-8.6l2.1-2.1",
  bot: "M12 8V4m0 0H8m4 0h4M5 8h14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2zm4 6h.01M15 14h.01",
  user: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z",
  clock: "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20zm0-15v5l3 2",
  msg: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10z",
  eye: "M2 12s4-7 10-7 10 7 10 7-4 7-10 7-10-7-10-7zm10 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6z",
  pause: "M6 4h4v16H6zM14 4h4v16h-4z",
  play_arrow: "M8 5v14l11-7L8 5z",
  settings:
    "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm7-3a7 7 0 0 0-.1-1.2l2-1.6-2-3.4-2.4.9a7 7 0 0 0-2.1-1.2L14 3h-4l-.4 2.5a7 7 0 0 0-2.1 1.2L5 5.8l-2 3.4 2 1.6a7 7 0 0 0 0 2.4l-2 1.6 2 3.4 2.4-.9a7 7 0 0 0 2.1 1.2L10 21h4l.4-2.5a7 7 0 0 0 2.1-1.2l2.4.9 2-3.4-2-1.6a7 7 0 0 0 .1-1.2z",
  flow: "M12 4v3m0 10v3m6-13l-2 2m-8 8l-2 2m12 0l-2-2m-8-8L6 6",
  target:
    "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20zm0-4a6 6 0 1 0 0-12 6 6 0 0 0 0 12zm0-3a3 3 0 1 0 0-6 3 3 0 0 0 0 6z",
  refresh: "M21 12a9 9 0 0 1-15 6.7M3 12a9 9 0 0 1 15-6.7M21 4v6h-6M3 20v-6h6",
  send: "M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z",
  history: "M3 12a9 9 0 1 0 3-6.7L3 8M3 3v5h5M12 7v5l4 2",
  plus: "M12 5v14M5 12h14",
  filter: "M3 6h18M6 12h12M10 18h4",
} as const;

export type IconName = keyof typeof PATHS;

const FILLED_ICONS: ReadonlySet<IconName> = new Set<IconName>(["star"]);

export interface IconProps {
  name: IconName;
  className?: string;
  style?: CSSProperties;
  /** Optional aria-label; when omitted the icon is decorative. */
  title?: string;
}

export function Icon({ name, className = "ic-svg", style, title }: IconProps) {
  const filled = FILLED_ICONS.has(name);
  const aria = title
    ? { role: "img" as const, "aria-label": title }
    : { "aria-hidden": true as const };
  return (
    <svg
      {...aria}
      data-icon={name}
      className={className}
      style={style}
      viewBox="0 0 24 24"
      fill={filled ? "currentColor" : "none"}
      stroke={filled ? "none" : "currentColor"}
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {title ? <title>{title}</title> : null}
      <path d={PATHS[name]} />
    </svg>
  );
}
